import { formatEuro } from '../../helpers/formatCurrency';
import { Resource as ResourceType } from '../types';

export const invoice: ResourceType = {
  name: 'invoices',
  label: 'resource.invoices.label',
  hideResource: false,
  subMenu: {
    name: 'invoices',
    items: [
      {
        key: 'client_invoices',
        path: 'client_invoices',
        label: 'resource.client_invoices.sub_menu.label',
      },
      {
        key: 'expert_invoices',
        path: 'expert_invoices',
        label: 'resource.expert_invoices.sub_menu.label',
      },
    ],
  },
  attributes: [
    {
      key: 'id',
      label: 'resource.invoices.field.id.label',
      type: 'text',
    },
    {
      key: 'company_name',
      label: 'resource.invoices.field.company_name.label',
      type: 'text',
    },
    {
      key: 'total_ttc',
      label: 'resource.invoices.field.total_ttc.label',
      type: 'number',
    },
    {
      key: 'total_ht',
      label: 'resource.invoices.field.total_ht.label',
      type: 'number',
    },
    {
      key: 'remaining_amount',
      label: 'remaining.amount.owed.label',
      type: 'number',
    },
    {
      key: 'guid',
      label: 'resource.invoices.field.guid.label',
      type: 'text',
    },
    {
      key: 'pdfs',
      label: 'resource.invoices.field.pdfs.label',
      type: 'buttons',
    },
    {
      key: 'contract_milestone_id',
      label: 'resource.invoices.field.contract_milestone_id.label',
      type: 'reference',
      reference: 'contract_milestones',
    },
    {
      key: 'credit_note_id',
      label: 'resource.invoices.field.credit_note_id.label',
      type: 'reference',
      reference: 'credit_notes',
    },
    {
      key: 'due_date',
      label: 'resource.invoices.field.due_date.label',
      type: 'date',
    },
    {
      key: 'payment_date',
      label: 'resource.invoices.field.payment_date.label',
      type: 'date',
    },
    {
      key: 'user_kind',
      label: 'resource.invoices.field.user_kind.label',
      type: 'select',
      choices: [
        {
          id: 'expert',
          name: 'resource.invoices.field.user_kind.choices.expert.label',
        },
        {
          id: 'client',
          name: 'resource.invoices.field.user_kind.choices.client.label',
        },
      ],
    },
    {
      key: 'status',
      label: 'resource.invoices.field.status.label',
      type: 'selectChoice',
    },
    {
      key: 'factor',
      label: 'resource.proposals.field.factor.label',
      type: 'boolean',
    },
    {
      key: 'client_platform_deposit',
      label: 'resource.invoices.field.client_platform_deposit.label',
      type: 'boolean',
    },
    {
      key: 'created_at',
      label: 'resource.invoices.field.created_at.label',
      type: 'date',
    },
    {
      key: 'updated_at',
      label: 'resource.invoices.field.updated_at.label',
      type: 'date',
    },
    {
      key: 'mission_id',
      label: 'resource.invoices.field.mission_id.label',
      type: 'reference',
      reference: 'missions',
    },
    {
      key: 'proposal_id',
      label: 'resource.invoices.field.proposal_id.label',
      type: 'reference',
      reference: 'proposals',
    },
    {
      key: 'company_id',
      label: 'resource.invoices.field.company_id.label',
      type: 'reference',
      reference: 'companies',
    },
    {
      key: 'client_company_id',
      label: 'resource.invoices.field.client_company_id.label',
      type: 'reference',
      reference: 'companies',
    },
    {
      key: 'leader_id',
      type: 'reference',
      reference: 'users',
    },
    {
      key: 'owner_id',
      type: 'reference',
      reference: 'users',
    },
    {
      key: 'client_owner_id',
      type: 'reference',
      reference: 'users',
    },
    {
      key: 'contract_milestone',
      type: 'object',
      shape: [
        {
          key: 'payment_period',
          label: 'resource.contract_milestones.field.payment_period.label',
          type: 'select',
          choices: [
            {
              id: 'forty_five_days',
              name: 'resource.contract_milestones.field.payment_period.choices.forty_five_days_x.label',
            },
            {
              id: 'thirty_days',
              name: 'resource.contract_milestones.field.payment_period.choices.thirty_days_x.label',
            },
            {
              id: 'fifteen_days',
              name: 'resource.contract_milestones.field.payment_period.choices.fifteen_days_x.label',
            },
            {
              id: 'seventy_two_hours',
              name: 'resource.contract_milestones.field.payment_period.choices.seventy_two_hours_x.label',
            },
            {
              id: 'payment_client',
              name: 'resource.contract_milestones.field.payment_period.choices.payment_client.label',
            },
            {
              id: 'fifteen_working_days',
              name: 'resource.contract_milestones.field.payment_period.choices.fifteen_working_days.label',
            },
            {
              id: 'five_working_days',
              name: 'resource.contract_milestones.field.payment_period.choices.five_working_days.label',
            },
            {
              id: 'immediate',
              name: 'resource.contract_milestones.field.payment_period.choices.immediate.label',
            },
          ],
        },
        {
          key: 'discount',
          label: 'resource.proposals.field.discount.label',
          type: 'number',
        },
        {
          key: 'vat',
          label: 'resource.contract_milestones.field.vat.label',
          type: 'number',
        },
        {
          key: 'professional_indemnity_percentage',
          label:
            'resource.proposals.field.professional_indemnity_percentage.label',
          type: 'number',
        },
        {
          key: 'professional_indemnity',
          label: 'resource.proposals.field.professional_indemnity.label',
          type: 'boolean',
        },
      ],
    },
    {
      key: 'billing_date',
      type: 'date',
      label: 'resource.invoices.field.invoices_at.label',
    },
    {
      key: 'proforma_pdfs',
      label: 'resource.invoices.field.proforma_pdfs.label',
      type: 'buttons',
    },
    {
      key: 'proforma_or_pdfs',
      label: 'resource.invoices.field.pdfs.label',
      type: 'buttons',
    },
    {
      key: 'attachments',
      label: '',
      type: 'file',
    },
  ],
  pages: {
    list: {
      hasEditButton: true,
      search: {
        enabled: true,
        label: 'filter.search.label',
      },
      bulkActionButtons: [
        {
          name: 'validate',
          type: 'update',
          label: 'resource.invoices.bulk_action_buttons.validate.label',
          values: {
            validated: true,
          },
        },
      ],
      filters: [
        {
          source: 'status',
          type: 'multipleSelect',
          optionsFilter: {
            className: 'multipleSelectFilter',
          },
        },
        {
          name: 'client_company_id',
          type: 'reference',
          reference: 'companies',
          label: 'resource.invoices.field.client_company_id.label',
          filter: { user_kind: 'client' },
          child: {
            type: 'autocomplete',
            optionText: 'name',
            options: {
              perPage: 10,
              allowEmpty: false,
            },
          },
        },
        {
          name: 'company_id',
          type: 'reference',
          reference: 'companies',
          label: 'resource.invoices.field.company_id.label',
          filter: { user_kind: 'expert' },
          child: {
            type: 'autocomplete',
            optionText: 'name',
            options: {
              perPage: 10,
              allowEmpty: false,
            },
          },
        },
        {
          source: 'billing_date',
          type: 'dateRange',
          label: 'resource.invoices.field.invoices_at.label',
        },
        {
          source: 'payment_date',
          type: 'dateRange',
          label: 'resource.invoices.field.payment_date.label',
        },
        {
          source: 'client_platform_deposit',
          type: 'boolean',
          label: 'resource.invoices.field.client_platform_deposit.label',
        },
      ],
      fields: [
        {
          source: 'guid',
        },
        {
          source: 'company_name',
        },
        {
          source: 'status',
        },
        {
          source: 'billing_date',
        },
        {
          source: 'payment_date',
        },
        {
          source: 'due_date',
        },
        {
          source: 'total_ht',
        },
        {
          source: 'total_ttc',
        },
        { source: 'remaining_amount' },
        {
          source: 'contract_milestone_id',
          child: {
            source: 'contract_milestones.title',
          },
        },
        {
          source: 'attachments',
          type: 'buttons',
          extensions: [
            {
              key: 'attachmentsFiles',
            },
          ],
        },
        {
          source: 'created_at',
        },
      ],
    },
    edit: {
      singleRedirect: {
        page: 'edit',
        basePath: '/invoices',
        recordId: 'id',
      },
      actions: [
        {
          name: 'cancel',
          type: 'modal',
          label: 'action.cancel.label',
          extraUrl: '/cancel',
          withConfirmation: true,
          values: { status: 'cancelled' },
          confirmation: {
            title: 'action.cancel.modal.title',
            content: 'action.cancel.modal.content',
          },
          disabled: [{ property: 'status', op: 'eq', value: 'cancelled' }],
          modal: {
            inputs: {},
          },
          rules: {
            hide: [
              {
                property: 'user_kind',
                op: 'eq',
                value: 'expert',
              },
            ],
          },
        },
        {
          name: 'resource.invoices.bulk_action_buttons.generate_a_new_invoice.label',
          type: 'modal',
          httpMethod: 'create',
          extraUrl: '/create',
          label:
            'resource.invoices.bulk_action_buttons.generate_a_new_invoice.label',
          withConfirmation: true,
          values: { createInvoice: 'true' },
          confirmation: {
            title: 'action.generate_a_new_invoice.modal.title',
            content: 'action.generate_a_new_invoice.modal.content',
          },
          disabled: [{ property: 'status', op: 'neq', value: 'cancelled' }],
          modal: {
            inputs: {},
          },
          rules: {
            hide: [
              {
                property: 'user_kind',
                op: 'eq',
                value: 'expert',
              },
            ],
          },
        },
      ],
      left: {
        tabs: [
          {
            key: 'information',
            title: 'resource.invoices.tab.information.title',
            sections: [
              {
                key: 'details',
                title: 'resource.invoices.section.details.title',
                layout: [
                  ['guid'],
                  ['status'],
                  ['factor'],
                  ['client_platform_deposit'],
                  ['user_kind'],
                  ['total_ht', 'total_ttc'],
                  ['billing_date'],
                  ['contract_milestone.vat'],
                  ['due_date'],
                  ['payment_date'],
                  [
                    'contract_milestone.discount',
                    'contract_milestone.payment_period',
                  ],
                ],
                inputs: {
                  guid: {
                    validators: [{ key: 'required' }],
                    label: 'resource.invoices.field.guid_name.label',
                  },
                  status: {
                    rules: {
                      disabled: [
                        {
                          property: 'status',
                          op: 'eq',
                          value: 'cancelled',
                        },
                        {
                          property: 'status',
                          op: 'eq',
                          value: 'proforma',
                        },
                      ],
                    },
                  },
                  factor: {
                    width: 6,
                    rules: {
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'expert',
                        },
                      ],
                    },
                  },
                  client_platform_deposit: {
                    width: 6,
                    rules: {
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'expert',
                        },
                      ],
                    },
                  },
                  user_kind: {
                    disabled: true,
                  },
                  total_ht: {
                    width: 6,
                    label: 'payment.amount.ht',
                    disabled: true,
                    rules: {
                      hide: [
                        {
                          property: 'contract_milestone_id',
                          op: 'absent',
                        },
                      ],
                    },
                  },
                  total_ttc: {
                    width: 6,
                    label: 'invoice.amount',
                    disabled: true,
                    rules: {
                      hide: [
                        {
                          property: 'contract_milestone_id',
                          op: 'absent',
                        },
                      ],
                    },
                  },
                  billing_date: {
                    validators: [{ key: 'required' }],
                  },
                  'contract_milestone.vat': {
                    width: 12,
                    validators: [
                      {
                        key: 'required',
                      },
                    ],
                    rules: {
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'client',
                        },
                      ],
                    },
                  },
                  due_date: {
                    validators: [{ key: 'required' }],
                  },
                  payment_date: {},
                  'contract_milestone.discount': {
                    width: 6,
                    extensions: [
                      {
                        key: 'multiplyByHundredInput',
                      },
                    ],
                    validators: [
                      {
                        key: 'required',
                      },
                      {
                        key: 'minValue',
                        value: 0,
                      },
                      {
                        key: 'maxValue',
                        value: 100,
                      },
                    ],
                    min: 0,
                    max: 100,
                    step: 0.01,
                    rules: {
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'client',
                        },
                      ],
                    },
                  },
                  'contract_milestone.payment_period': {
                    width: 6,
                    extensions: [
                      {
                        key: 'disabledByDate',
                      },
                    ],
                    validators: [
                      {
                        key: 'required',
                      },
                    ],
                    rules: {
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'client',
                        },
                      ],
                    },
                  },
                  'contract_milestone.professional_indemnity': {
                    width: 6,
                    initialValue: false,
                    validators: [
                      {
                        key: 'required',
                      },
                    ],
                    rules: {
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'client',
                        },
                      ],
                    },
                  },
                  'contract_milestone.professional_indemnity_percentage': {
                    width: 6,
                    validators: [
                      {
                        key: 'required',
                        rules: [
                          {
                            property:
                              'contract_milestone.professional_indemnity',
                            op: 'eq',
                            value: true,
                          },
                        ],
                      },
                      {
                        key: 'minValue',
                        value: 0,
                      },
                      {
                        key: 'maxValue',
                        value: 100,
                      },
                    ],
                    min: 0,
                    max: 100,
                    step: 0.01,
                    rules: {
                      disabled: [
                        {
                          property: 'contract_milestone.professional_indemnity',
                          op: 'eq',
                          value: false,
                        },
                      ],
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'client',
                        },
                      ],
                    },
                    extensions: [
                      {
                        key: 'multiplyByHundredInput',
                      },
                    ],
                  },
                },
              },
              {
                key: 'payments',
                title: 'resource.invoices.section.payments.title',
                layout: [['remaining_amount']],
                fields: {
                  remaining_amount: {
                    addLabel: true,
                    title: 'remaining.amount.owed.label',
                    source: 'remaining_amount',
                    type: 'number',
                    format: formatEuro,
                  },
                },
                rules: {
                  hide: [{ property: 'user_kind', op: 'eq', value: 'client' }],
                },
                inputs: {},
              },
              {
                key: '',
                title: '',
                layout: [],
                relatedRecord: {
                  recordToCreate: 'payments',
                  addRecordLabel: 'action.add_payment_button.title',
                  modalTitle: 'action.add_payment_button.title',
                  filter_attribute: 'invoice_id',
                  filter_resource: 'invoice',
                  inputs: {
                    amount: {
                      type: 'number',
                      width: 6,
                      showEuro: true,
                      validators: [
                        { key: 'required' },
                        { key: 'minValue', value: 0 },
                      ],
                    },
                    partial_payment_date: {
                      type: 'date',
                      width: 6,
                      validators: [{ key: 'required' }],
                    },
                  },
                },
                rules: {
                  hide: [{ property: 'user_kind', op: 'eq', value: 'client' }],
                },
                inputs: {},
              },

              {
                key: 'download',
                title: 'resource.invoices.section.download.title',
                layout: [['pdfs'], ['attachments'], ['proforma_pdfs']],
                inputs: {
                  attachments: {
                    validators: [{ key: 'required' }],
                  },
                },
                fields: {
                  pdfs: {
                    addLabel: true,
                    extensions: [
                      {
                        key: 'multipleLangFiles',
                      },
                    ],
                  },
                  proforma_pdfs: {
                    addLabel: true,
                    extensions: [
                      {
                        key: 'multipleLangFiles',
                      },
                    ],
                    rules: {
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'client',
                        },
                      ],
                    },
                  },
                },
              },
            ],
          },
        ],
      },
      right: [
        {
          sections: [
            {
              key: 'details',
              title: 'resource.invoices.section.infos.title',
              layout: [['id'], ['created_at'], ['updated_at']],
              inputs: {
                id: {
                  disabled: true,
                },
                updated_at: {
                  disabled: true,
                },
                created_at: {
                  disabled: true,
                },
              },
              fields: {},
            },
          ],
        },
        {
          sections: [
            {
              key: 'links',
              title: 'resource.invoices.section.links.title',
              layout: [
                ['contract_milestone_id'],
                ['credit_note_id'],
                ['mission_id'],
                ['proposal_id'],
                ['leader_id'],
                ['leader_company_name'],
                ['client_owner_id'],
                ['client_company_name'],
              ],
              inputs: {},
              fields: {
                contract_milestone_id: {
                  addLabel: true,
                  child: {
                    source: 'contract_milestones.title',
                    type: 'text',
                  },
                },
                credit_note_id: {
                  addLabel: true,
                  child: {
                    source: 'credit_notes.guid',
                    type: 'text',
                  },
                  rules: {
                    hide: [
                      {
                        property: 'status',
                        op: 'neq',
                        value: ['cancelled'],
                      },
                    ],
                  },
                },
                mission_id: {
                  addLabel: true,
                  label: 'resource.invoices.field.mission_id.label',
                  source: 'mission_id',
                  child: {
                    type: 'text',
                    source: 'missions.name',
                  },
                },
                proposal_id: {
                  addLabel: true,
                  source: 'proposal_id',
                  label: 'resource.invoices.field.proposal_id.label',
                  child: {
                    type: 'text',
                    source: 'proposals.guid',
                  },
                },
                leader_id: {
                  addLabel: true,
                  source: 'owner_id',
                  label: 'resource.proposals.field.candidacy_owner_name.label',
                  child: {
                    type: 'text',
                    source: 'users.full_name',
                  },
                },
                leader_company_name: {
                  addLabel: true,
                  link: false,
                  source: 'owner_id',
                  label: 'resource.users.field.company_name_profile.label',
                  child: {
                    type: 'text',
                    source: 'users.company_name',
                  },
                },
                client_owner_id: {
                  addLabel: true,
                  label: 'resource.candidacies.field.company_name.label',
                  child: {
                    type: 'text',
                    source: 'users.full_name',
                  },
                },
                client_company_name: {
                  addLabel: true,
                  link: false,
                  source: 'client_owner_id',
                  label: 'resource.missions.field.company_id.label',
                  child: {
                    type: 'text',
                    source: 'users.company_name',
                  },
                },
              },
            },
          ],
        },
        {
          sections: [
            {
              key: 'history',
              title: 'resource.companies.section.history.title',
              layout: [],
              inputs: {},
              history: true,
              filterResource: 'invoices',
              filterAttribute: 'id',
            },
          ],
        },
      ],
    },
  },
};
